import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

export class Spinner {
  color: ThemePalette;
  fullScreen: boolean;
  mode?: ProgressSpinnerMode;
  name: string;
  overlay: boolean;
  show: boolean;
  strokeWidth?: number;
  value?: number;
  zIndex: number = 10000;
  text: string = '';

  constructor(spinner?: Partial<Spinner>) {
    Object.assign(this, spinner);
  }

  static create(spinner?: Partial<Spinner>): Spinner {
    return new Spinner(spinner);
  }
}
